// redux/actions/desvinculaciones/types.js
export const FETCH_DESVINCULACIONES_SUCCESS = "FETCH_DESVINCULACIONES_SUCCESS";
export const FETCH_DESVINCULACIONES_FAILURE = "FETCH_DESVINCULACIONES_FAILURE";
export const FETCH_AUDIT_LOG_DESVINCULACION_SUCCESS = "FETCH_AUDIT_LOG_DESVINCULACION_SUCCESS";
export const FETCH_AUDIT_LOG_DESVINCULACION_FAILURE = "FETCH_AUDIT_LOG_DESVINCULACION_FAILURE";